<!--
* @Name：跨组织调拨物料信息明细页面
* @Author: 王超
* @Date: 2022-03-09
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.inMaktx }}</span>
      </van-row>
      <van-row>
        <span>版本：</span>
        <span>{{ item.versionNo }}</span>
      </van-row>
      <van-row>
        <span>最小包装数量：</span>
        <span>{{ item.bstrf }}</span>
      </van-row>
      <van-row>
        <span>申请数量：</span>
        <span>{{ item.applyQty }}</span>
      </van-row>
      <van-row>
        <span>调拨数量：</span>
        <span>{{ item.allotQty }}</span>
      </van-row>
      <van-row>
        <span>物料类型：</span>
        <span>{{ item.mtart }}</span>
      </van-row>
      <van-row>
        <span>采购单位：</span>
        <span>{{ item.bstme }}</span>
      </van-row>
      <van-row>
        <span>调拨单价：</span>
        <span>{{ item.allotPrice }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
import { selectDetail } from '@/api/cotRequest'
export default {
  name: 'MaterialDetails',
  data() {
    return {
      // 物料明细列表
      detailsList: []
    }
  },
  props: {},
  computed: {},
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      // const detailsResp = await selectDetail(this.$store.getters.businessKey)
      const detailsResp = await selectDetail(this.$route.query.businessKey)
      this.detailsList = detailsResp.data
      console.log('物料明细：=======', JSON.stringify(this.detailsList))
    }
  }
}
</script>
